import * as angular from 'angular';

import { ComponentDefinition } from '../../../../models';

class ApproveAllModalController implements angular.IComponentController {
    message: string;
    title: string;
    
    readonly approveAll: () => void;
    readonly status: number;

    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if(changesObj['status']){
            this.title = `${this.status >= 0 ? 'Approve' : 'Reject'} all`;
            this.message = `Do you want to ${this.status >= 0 ? 'approve' : 'reject'} all groups for selected month?`;
        }
    }
}

export const wtApproveAllModal: ComponentDefinition = {
    componentId: 'wtApproveAllModal',
    controller: ApproveAllModalController,
    template: require('./approveAllModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        approveAll: '&',
        status: '<'
    }
};
